export const getMappedDocumentsObject = (documents: readonly Record<string, unknown>[]): Record<number, string> => {
  return documents.reduce<Record<number, string>>((obj, document, index) => {
    obj[index] = document.id as string;
    return obj;
  }, {});
};
